/**
 * Created by PhpStorm on 08.05.2017.
 * Author: Shabalin Pavel
 * Email: aisamiery@gmail.com
 */
'use strict';

require('../core/core');
require('../../modules/pagination/pagination');
require('../../modules/forms/forms');

require('../../models/user/userMembership');
require('../../models/subclub/subclub');

require('../../forms/inviteUserForm');
require('../../forms/subclubEditForm');
require('../../forms/themes/inviteUser/inviteUser.theme');

require('../../helpers/show-modal-message/show-modal-message');

require('../fos_user/directives/unique-user');

angular.module('far.subclub', [
    'ngTouch',
    'ngMessages',
    'angularFileUpload',
    'ui.select',
    'ui.bootstrap',
    'dekky.pagination',
    'dekky.forms',
    'far.models.userMembership',
    'far.models.subclub',
    'far.core',
    'far.forms.inviteUserForm',
    'far.forms.subclubEditForm',
    'dekky.forms.themes.inviteUser',
    'far.helpers.showModalMessage',
    'far.fos_user.uniqueUser'
]).value('formsConfig', {
    theme: '/dekky.forms/themes/far'
});